import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { login } from "../../Store/Login/LoginAction";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Checkbox } from "primereact/checkbox";
import "./LoginStyle.scss";

const LoginContent = ({ handleForgotPasswordClick }) => {
  const [checked, setChecked] = useState(false);
  const [loginId, setLoginId] = useState("");
  const [password, setPassword] = useState("");
  const [passwordRequiredMessage, setPasswordRequiredMessage] = useState(false);
  const [loginIdRequiredMessage, setLoginIdRequiredMessage] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    const savedLoginId = localStorage.getItem("loginId");
    const savedPassword = localStorage.getItem("password");
    if (savedLoginId) {
      setLoginId(savedLoginId);
      setChecked(true);
    }
    if (savedPassword) {
      setPassword(savedPassword);
    }
  }, []);

  const handleLogin = () => {
    dispatch(login(loginId, password, navigate));
    if (checked) {
      localStorage.setItem("loginId", loginId);
      localStorage.setItem("password", password);
    } else {
      localStorage.removeItem("loginId");
      localStorage.removeItem("password");
    }
  };

  const handleNewUserClick = () => {
    navigate("/Login/new-password");
  };

  const requiredLoginId = (e) => {
    setLoginId(e.target.value);
    setLoginIdRequiredMessage(e.target.value === "");
  };

  const requirePassword = (e) => {
    setPassword(e.target.value);
    setPasswordRequiredMessage(e.target.value === "");
  };

  const handleTogglePassword = () => {
    setShowPassword(!showPassword);
  };

  return (
    <>
      <div>
        <div className="text-blue-900 font-semibold text-4xl">Welcome !</div>
        <div className="text-500 text-sm w-30rem">
          Enter Your Credentials To Access Your Account
        </div>
        <div className="flex">
          <p className="mr-1 mb-3 pinkcolor">*</p>
          <p className="text-blue-900 font-semibold">Login ID</p>
        </div>
        <div>
          <InputText
            className="custom-input w-30rem mr-4"
            value={loginId}
            onChange={requiredLoginId}
            data-testid="loginId-input"
            onBlur={(e) => requiredLoginId(e)}
          />
          {loginIdRequiredMessage && (
            <div className="text-red-500 text-sm">Login Id is required.</div>
          )}
        </div>
        <div className="flex">
          <p className="mr-1 mb-3 pinkcolor">*</p>
          <p className="text-blue-900 font-semibold">Password</p>
        </div>
        <div className="p-inputgroup w-30rem mr-4">
          <InputText
            type={showPassword ? "text" : "password"}
            value={password}
            onChange={requirePassword}
            data-testid="password-input"
            onBlur={(e) => requirePassword(e)}
            style={{ borderRight: "none", height: "2.6rem" }}
          />
          <button
            className={`pi-button`}
            onClick={handleTogglePassword}
            aria-label={showPassword ? "Hide password" : "Show password"}
            style={{
              border: "1px solid #ccc",
              backgroundColor: "transparent",
              borderLeft: "none",
            }}
          >
            <i className={`pi ${showPassword ? "pi-eye" : "pi-eye-slash"}`} />
          </button>
        </div>
        {passwordRequiredMessage && (
          <div className="text-red-500 text-sm">Password is required.</div>
        )}
      </div>
      <div className="flex flex-row flex-wrap gap-3 mt-4">
        <div className="flex">
          <Checkbox
            className="custom-checkbox"
            onChange={() => setChecked(!checked)}
            checked={checked}
            data-testid="remember-checkbox"
          />
        </div>
        <div className="text-blue-900 text-sm font-semibold mb-2">
          Remember Me
        </div>
      </div>
      <Button
        className="login-btn w-30rem"
        onClick={() => {
          setLoginIdRequiredMessage(loginId === "");
          setPasswordRequiredMessage(password === "");
          if (loginId !== "" && password !== "") {
            handleLogin();
          }
        }}
        data-testid="submit-button"
      >
        Submit
      </Button>
      <div className="flex justify-content-center mt-4 w-30rem">
        {/* <div
          className="flex text-sm font-semibold cursor-pointer"
          style={{ color: "#E03581" }}
          onClick={handleNewUserClick}
        >
          New User?
        </div> */}
        <div
          className="flex text-sm font-semibold cursor-pointer"
          style={{ color: "#1D2965" }}
          onClick={handleNewUserClick}
        >
          Please Reset Your Password From Here.
        </div>
      </div>
    </>
  );
};

export default LoginContent;
